import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { fetchChallengeWireSummary } from '../utils/challengeWireApi';

export default function useChallengeWireSummary(user, endpoints, csrfToken, { enabled = true } = {}) {
	const { activeFitnessProfile } = useAuth();
	const [summary, setSummary] = useState({
		incoming_friend_requests: 0,
		pending_challenges: 0,
		active_challenges: 0,
		trainer_briefings: 0
	});

	useEffect(() => {
		if (!enabled || !user?.id || !endpoints?.get_user_challenge_wire_summary_endpoint) return;
		fetchChallengeWireSummary({
			userId: user.id,
			endpoint: endpoints.get_user_challenge_wire_summary_endpoint,
			csrfToken
		})
			.then(setSummary)
			.catch(() => {});
	}, [enabled, user?.id, endpoints, csrfToken, activeFitnessProfile?.id]);

	return summary;
}
